export const COLLECTIONS = {
  TABLES: 'tables-dummy',
  BOOKINGS: 'table-bookings',
  CATEGORIES: 'categories-dummy',
} as const;
